/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Scope_TitleInputs */

const en_svc_integration_scope_title = /** @type {(inputs: Svc_Integration_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where AI integration helps.`)
};

const lv_svc_integration_scope_title = /** @type {(inputs: Svc_Integration_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kur AI integrācija palīdz.`)
};

/**
* | output |
* | --- |
* | "Where AI integration helps." |
*
* @param {Svc_Integration_Scope_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_scope_title = /** @type {((inputs?: Svc_Integration_Scope_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Scope_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_scope_title(inputs)
	return en_svc_integration_scope_title(inputs)
});